<template>
  <v-app id="app" :class="`${isEmbedded?'view--embedded':'view--normal'} tenant--${tenant.id}`">
    <v-app-bar
      v-if="!isEmbedded"
      app
      color="header"
      :class="$route.meta.toolbarClass"
      dark
      extended
      extension-height="4"
      elevate-on-scroll
    >
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.xs" @click="drawer = true"><v-icon>fa-bars</v-icon></v-app-bar-nav-icon>
      <router-link to="/" class="pa-0 logo">
        <img v-if="false && $vuetify.breakpoint.xsOnly" src="/images/logo-white.svg" alt="Logo sodisp" class="ml-4" height="32" width="89" />
        <img v-else :src="tenant.headerLogoUrl" alt="Logo sodisp" class="ml-4" height="32" style="max-width:200px;" />
      </router-link>
      <!--<v-toolbar-title><v-btn text to="/" exact class="px-0">sodisp</v-btn></v-toolbar-title>--> 
      <v-spacer/>
      
      <template v-if="!$vuetify.breakpoint.xsOnly">
        <template v-for="(item, i) in $store.state.nav['menu-'+tenant.navPostfix]">
          <v-btn :key="i" text :to="item.to"><v-icon class="mr-2 d-none">{{item.icon}}</v-icon>{{$t('nav.header.' + item.text_key)}}</v-btn>
        </template>
        <v-menu offset-y v-if="(false || true) && tenant.isDefault">
          <template v-slot:activator="{ on }">
            <v-btn text class=" ml-0" v-on="on">
              {{$t('nav.header.solutions')}}
              <v-icon color="white" class="ml-1">fal fa-angle-down</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <template v-for="(item, i) in $store.state.nav['solutions-menu-default']">
                <v-divider v-if="item.divider" :key="i" class="my-4" />
                <v-list-item v-else :key="i" link :to="item.to" exact>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.text_key ? $t('nav.account.' + item.text_key) : item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </v-menu>              
      </template>
      <AccountMenu />
      <v-progress-linear slot="extension"  v-if="isHttpRequestLoading" indeterminate color="progress" class="ajax-loader ma-0"></v-progress-linear>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list-item to="/">
        <v-list-item-content>
          <v-list-item-title class="title">
            <div><img :src="tenant.logoUrl" alt="Logo sodisp" width="200" /></div>
            <!--<strong>sodisp</strong>.com-->
          </v-list-item-title>
          <v-list-item-subtitle>
            Challenge Platform
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider dark class="my-4"/>
      <v-list dense>
        <template v-for="(item, i) in $store.state.nav['drawer-'+tenant.navPostfix]">
          <v-list-item v-if="item.heading || item.heading_key" :key="i">
            <v-list-item-content>
              <v-list-item-title class="subtitle">
                {{ item.heading_key ? $t('nav.header.' + item.heading_key) : item.heading }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-else-if="item.divider" :key="i" dark class="my-4" />
          <v-list-item v-else :key="i" link :to="item.to">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                {{ item.text_key ? $t('nav.header.' + item.text_key) : item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn color="primary" block to="/me">My Profile</v-btn>
        </div>
      </template>    
    </v-navigation-drawer>    
    <!-- <v-progress-linear v-if="isHttpRequestLoading" indeterminate color="yellow darken-2" class="ajax-loader"></v-progress-linear> -->
    <div v-if="$route.meta.contentLayout" id="page-hero" class="container px-0 py-6 py-md-12 white--text py-md-12 container--fluid">
      <div class="container">
        <h1 v-if="!pageImage" class="display-2">{{pageTitle}}</h1>
        <div v-if="pageImage" class="d-flex flex-row flex-sm-row">
          <h1 class="display-2 width-50p align-self-end" :class="{'display-1': $vuetify.breakpoint.xs}">{{pageTitle}}</h1>
          <img class="width-50p illustration" :src="pageImage" :alt="pageTitle" /> 
        </div>
      </div>
    </div>
    <v-main v-if="!$route.meta.noLayout">
      <v-container>
        <v-row>
          <v-col>
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <router-view v-if="$route.meta.noLayout"></router-view>
    <v-footer
      v-if="!isEmbedded && tenant.isDefault"
      dark
      padless
    >
      <v-row
        justify="center"
        no-gutters
      >
        <v-col 
          v-if="false"
          class="green py-4 px-4 text-center white--text"
          cols="12"
        >
          We are in <code>beta</code> phase. See anything strange? Have a comment or tip? We'd <router-link to="/contact" class="white--text">love to hear from you</router-link>!
        </v-col>
        <v-btn
          v-for="(item, i) in $store.state.nav['footer-default']"
          :key="i"
          :to="item.to"
          color="white"
          text
          rounded
          class="my-2"
        >
          {{ item.text_key ? $t('nav.header.' + item.text_key) : item.text }}
        </v-btn>
        <v-col 
          class="copyright-container py-4 text-center white--text"
          cols="12"
        >
          <img src="/images/logo-black.svg" class="float-left mx-2" width="100" alt="Logo sodisp" />
          &copy; {{ new Date().getFullYear() }} — <a href="https://sodisp.com">sodisp.com</a>
          <div>
          <router-link to="/privacypolicy" class="white--text">{{$t('nav.footer.privacy')}}</router-link>
          |
          <router-link to="/cookiepolicy" class="white--text">{{$t('nav.footer.cookies')}}</router-link>
          |
          <router-link to="/termsofservice" class="white--text">{{$t('nav.footer.terms-of-service')}}</router-link>
          |
          <LanguageMenu/>

          </div>
        </v-col>
      </v-row>
    </v-footer>
    <v-footer
      v-else-if="!tenant.isDefault"
      class="custom-footer"
      padless
    >
      <v-row justify="center" no-gutters>
        <v-btn
          v-for="(link, i) in $store.state.nav.footer_embedded"
          :key="i"
          :to="link.to"
          color="primary"
          text
          rounded
          class="my-2 nav-item"
        >
          {{ link.text_key ? $t('nav.header.' + link.text_key) : link.text }}
        </v-btn>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" md="8" class="py-4 px-4 powered-by">
          <h4>Powered by <a href="https://sodisp.com" target="_blank">sodisp - Challenge Platform</a></h4>
          sodisp (short for <strong>so</strong>cial <strong>di</strong>stancing <strong>sp</strong>orts) is the most powerful platform to host endurance sports events and challenges. We offer Strava, Garmin, Polar and Fitbit integration, 6 challenge modes and numerous powerful features to create engaging virtual experiences! <a href="https://sodisp.com" class="" @click="resetViewMode" target="_blank">Learn how  &raquo;</a>
        </v-col>
        <v-col cols="12" md="4" class="py-4 px-4 d-flex flex-column justify-start align-start align-md-end powered-by">
          <h4>Powered by</h4>
          <a href="https://sodisp.com" target="_blank"><img src="/images/logo-sodisp.svg" class="mx-2 my-2" style="max-width:100px;" alt="Logo sodisp"/></a>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col 
          class="py-4 px-4 text-center legal-info d-flex flex-column flex-sm-row align-center"
          cols="12"
        >
          <span>{{ new Date().getFullYear() }} — <a href="https://sodisp.com" target="_blank">sodisp.com</a></span>
          <v-spacer/>
          <div>
            <router-link to="/privacypolicy" class="">{{$t('nav.footer.privacy')}}</router-link>
            |
            <router-link to="/cookiepolicy" class="">{{$t('nav.footer.cookies')}}</router-link>
            |
            <router-link to="/termsofservice" class="">{{$t('nav.footer.terms-of-service')}}</router-link>
          </div>
          <v-spacer/>
          <LanguageMenu style="color:black !important;"/>
        </v-col>
      </v-row>
    </v-footer>
    <v-footer
      v-else-if="isEmbedded"
      padless
      class="py-4"
    >
      <v-row no-gutters>
        <v-col cols="12" class="px-4 powered-by d-flex flex-column flex-sm-row align-center">
          <h4>Powered by <a href="https://sodisp.com" target="_blank">sodisp - Challenge Platform</a></h4>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col 
          class="px-4 text-center legal-info d-flex flex-column flex-sm-row align-center"
          cols="12"
        >
          <span>&copy; {{ new Date().getFullYear() }} — <a href="https://sodisp.com" target="_blank">sodisp.com</a></span>
          <v-spacer/>
          <div>
            <router-link to="/privacypolicy" class="">{{$t('nav.footer.privacy')}}</router-link>
            |
            <router-link to="/cookiepolicy" class="">{{$t('nav.footer.cookies')}}</router-link>
            |
            <router-link to="/termsofservice" class="">{{$t('nav.footer.terms-of-service')}}</router-link>
          </div>
          <v-spacer/>
          <LanguageMenu style="color:black !important;"/>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<style v-if="tenant.customCss" :src="`/styles/${tenant.customCss}`"></style>
<!--<style src="./assets/css/vruk.css"></style>-->

<style src="./assets/css/site.css"></style>
<style src="./styles/global.scss" lang="scss"></style>
<style lang="scss">
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .ajax-loader.v-progress-linear {
    /*top: 64px;*/
  }
  .v-app-bar a.logo { line-height: 0;}
  .v-toolbar__title .v-btn { text-transform: inherit !important; font-family: 'Lora', serif; line-height: 18px; font-weight: 700;; font-size: 18px; letter-spacing: 0 !important; }
  .v-toolbar__title .v-btn:before { display: none; }
  .v-toolbar__content, .v-toolbar__extension { padding: 0 !important; }
  /*.v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:last-child, .v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:last-child { margin-right: 0!important;}*/
  .v-application--is-ltr .v-toolbar__content > .v-btn:last-child, .v-application--is-ltr .v-toolbar__extension > .v-btn:last-child { margin-right: 8px!important;}
  body header.v-app-bar--is-scrolled {
    background: linear-gradient(to right, var(--v-header-base), var(--v-gradient-base)) !important; 
  }

  .view--embedded {
    .v-main__wrap > .container { padding-top: 0;}
    .v-breadcrumbs { padding-top: 0; }
  } 
</style>

<script>
  import { mapGetters } from "vuex";
  import { EventBus } from '@/plugins/eventbus.js';
  import ShareButton from "@/components/ShareButton.vue";
  import AccountMenu from "@/components/AccountMenu.vue";
  import LanguageMenu from "@/components/LanguageMenu.vue";
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import tenants from '@/data/tenants.config'
  const tenant = tenants.current();

  export default {
    props: {
      source: String,
    },
    components: {
      ShareButton,
      AccountMenu,
      LanguageMenu,
    },
    data: () => ({
      drawer: false,
      titleOverride: null,
      imageOverride: null,
      tenant: tenant,
    }),
    mounted() {
      if (tenant.customCss) {
        // Must add as dynamic element to prevent webpack from optimizing this away
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `/styles/${tenant.customCss}`;
        document.head.appendChild(link);
      }
      if (tenant.favIconUrl) {
        document.getElementById('favicon').href = tenant.favIconUrl;
      }

      EventBus.$on('page-header-change', data => {
        //this.titleOverride = data.title;
        //this.imageOverride = data.image;
      });
      let params = new URLSearchParams(window.location.search);
      const view = params.get("view"); // note: this.$route.query.view doesn't work on hard-refreshes!
      if (view) {
        this.$store.commit("setViewMode", view);
      }

      window.addEventListener('click', event => {
        // ensure we use the link, in case the click has been received by a subelement
        let { target } = event;
        while (target && target.tagName !== 'A') target = target.parentNode
        // handle only links that do not reference external resources
        if (target && target.matches(".dynamic-content a:not([href*='://'])") && target.href) {
          // some sanity checks taken from vue-router:
          // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
          const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = event
          // don't handle with control keys
          if (metaKey || altKey || ctrlKey || shiftKey) return
          // don't handle when preventDefault called
          if (defaultPrevented) return
          // don't handle right clicks
          if (button !== undefined && button !== 0) return
          // don't handle if `target="_blank"`
        
          if (target && target.getAttribute) {
            const linkTarget = target.getAttribute('target')
            if (/\b_blank\b/i.test(linkTarget)) return
          }
          // don't handle same page links/anchors
          const url = new URL(target.href)
          const to = url.pathname
          if (window.location.pathname !== to && event.preventDefault) {
            event.preventDefault()
            this.$router.push(to)
          }
        }
      });
    },
    methods: {
      resetViewMode() {
        this.$store.dispatch('setViewMode', null);
      },
      async signOut() {
        await firebase.auth().signOut();
        this.$store.dispatch('setUser', null);
        this.$router.replace({ name: "home" });
      },
    },
    computed: {
      isHttpRequestLoading () {
        return this.$store.getters.loading
      },
      pageTitle() {
        return this.titleOverride || this.$route.meta.title;
      },
      pageImage() {
        return this.imageOverride || (this.$route.meta.illustration ? '/illustrations/'+this.$route.meta.illustration : null);
      },
      isEmbedded() {
        return this.$route.query.view === 'embed' || this.$store.state.view == 'embed';
      },
      ...mapGetters({
        user: "user"
      })
    }

  }
</script>